import React, { useEffect, useState } from "react";
import { SensorOpenIcon, SensorClosedIcon } from "./icon/contact-sensor-icons";

const ContactSensor1Widget = ({ widget, onValueUpdate }) => {
  const [value, setValue] = useState(null);
  const [widgetData, setWidgetData] = useState(null);

  useEffect(() => {
    if (!widget) return;
    setWidgetData(widget);

    if (widget.items?.$w1) {
      const currentValue = widget.items.$w1.value;
      setValue(
        currentValue === "" || currentValue === null ? "close" : currentValue
      );
    }
  }, [widget]);

  const getStatusText = () => {
    if (!value) return "close";
    return value;
  };

  const getContactIcon = () => {
    return value === "open" ? (
      <SensorOpenIcon style={{ fontSize: "1.2rem" }} />
    ) : (
      <SensorClosedIcon style={{ fontSize: "1.2rem" }} />
    );
  };

  return (
    <div
      className="flex items-center justify-center gap-2 w-full border rounded-2xl transition-colors duration-300"
      style={{
        height: "40px",
        borderColor:
          value === "open" ? "hsl(var(--primary))" : "hsl(var(--border))",
      }}
    >
      {getContactIcon()}
      <span className="text-[0.925rem] font-medium capitalize whitespace-nowrap overflow-hidden text-ellipsis max-w-full">
        {getStatusText()}
      </span>
    </div>
  );
};

export default ContactSensor1Widget;
